module.exports = __webpack_public_path__ + "static/media/logo-t-cito-black-typo.f2ce8645.svg";